module.exports = __webpack_public_path__ + "media/images/logo--medium-93e03d70f3e476f232408c4919df20f1.png";